var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstitutionBranding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 126,
    viewBox: "0 0 247 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 126,
    rx: 8,
    fill: "#F5FBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H239V115H11V11Z",
    stroke: "#D0D5DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239 118C240.657 118 242 116.657 242 115C242 113.343 240.657 112 239 112C237.343 112 236 113.343 236 115C236 116.657 237.343 118 239 118Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239 66C240.657 66 242 64.6569 242 63C242 61.3431 240.657 60 239 60C237.343 60 236 61.3431 236 63C236 64.6569 237.343 66 239 66Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239 14C240.657 14 242 12.6569 242 11C242 9.34315 240.657 8 239 8C237.343 8 236 9.34315 236 11C236 12.6569 237.343 14 239 14Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 118C12.6569 118 14 116.657 14 115C14 113.343 12.6569 112 11 112C9.34315 112 8 113.343 8 115C8 116.657 9.34315 118 11 118Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125 119C126.657 119 128 117.657 128 116C128 114.343 126.657 113 125 113C123.343 113 122 114.343 122 116C122 117.657 123.343 119 125 119Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125 14C126.657 14 128 12.6569 128 11C128 9.34315 126.657 8 125 8C123.343 8 122 9.34315 122 11C122 12.6569 123.343 14 125 14Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 66C12.6569 66 14 64.6569 14 63C14 61.3431 12.6569 60 11 60C9.34315 60 8 61.3431 8 63C8 64.6569 9.34315 66 11 66Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M159 71.5C167.008 71.5 173.5 77.9919 173.5 86C173.5 94.0081 167.008 100.5 159 100.5C150.992 100.5 144.5 94.0081 144.5 86C144.5 77.9919 150.992 71.5 159 71.5Z",
    fill: "#875BF7",
    stroke: "white",
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M136 71.5C144.008 71.5 150.5 77.9919 150.5 86C150.5 94.0081 144.008 100.5 136 100.5C127.992 100.5 121.5 94.0081 121.5 86C121.5 77.9919 127.992 71.5 136 71.5Z",
    fill: "#6030E1",
    stroke: "white",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113 71.5C121.008 71.5 127.5 77.9919 127.5 86C127.5 94.0081 121.008 100.5 113 100.5C104.992 100.5 98.5 94.0081 98.5 86C98.5 77.9919 104.992 71.5 113 71.5Z",
    fill: "#F38744",
    stroke: "white",
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90 72C97.732 72 104 78.268 104 86C104 93.732 97.732 100 90 100C82.268 100 76 93.732 76 86C76 78.268 82.268 72 90 72Z",
    fill: "#0BA5EC",
    stroke: "white",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4730_3321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.266 28.6582L110.816 30.6328C107.604 30.9963 105.351 33.4785 105.784 36.1769L108.134 50.8349C108.567 53.5334 111.522 55.4262 114.734 55.0627L132.184 53.0882C135.396 52.7247 137.649 50.2425 137.216 47.544L134.866 32.886C134.433 30.1876 131.478 28.2947 128.266 28.6582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.494 42.4393L117.152 39.1823L115.943 42.8417L119.494 42.4393ZM113.346 46.4204L113.31 46.1936C113.701 46.1116 113.977 45.9557 114.14 45.7252C114.307 45.4935 114.558 44.8883 114.893 43.9097L117.124 37.381L117.426 37.3465L122.414 44.033C122.746 44.4779 122.997 44.7497 123.167 44.8464C123.34 44.9395 123.61 44.9863 123.979 44.9863L124.016 45.2131L120.087 45.6574L120.05 45.4307C120.498 45.3468 120.784 45.2747 120.906 45.215C121.03 45.1515 121.076 45.027 121.046 44.8434C121.037 44.7817 120.994 44.677 120.919 44.5266C120.837 44.3652 120.74 44.2092 120.629 44.0601L119.795 42.9243L115.753 43.3816C115.584 43.9101 115.423 44.4403 115.271 44.9722C115.224 45.1607 115.21 45.308 115.227 45.4146C115.261 45.6272 115.39 45.7622 115.614 45.8201C115.753 45.8546 116.005 45.8633 116.371 45.8472L116.408 46.074L113.346 46.4204ZM127.852 41.3189C127.299 41.5396 126.849 41.7657 126.502 41.9968C125.836 42.4424 125.541 42.8966 125.615 43.3588C125.675 43.7304 125.869 43.9874 126.199 44.1291C126.414 44.2215 126.642 44.2542 126.882 44.2265C127.218 44.1877 127.534 44.0719 127.796 43.8918C128.079 43.7063 128.201 43.4968 128.164 43.2633L127.852 41.3189ZM124.34 43.9331C124.245 43.3403 124.531 42.8048 125.196 42.3253C125.619 42.0276 126.488 41.5901 127.803 41.0127L127.719 40.4913C127.653 40.0741 127.556 39.7888 127.429 39.6372C127.214 39.3826 126.838 39.2859 126.299 39.3463C126.043 39.3752 125.808 39.456 125.594 39.5885C125.381 39.7253 125.289 39.8898 125.32 40.0815C125.327 40.1308 125.354 40.2134 125.398 40.3292C125.442 40.4401 125.466 40.5129 125.471 40.5455C125.508 40.7748 125.44 40.9449 125.268 41.0558C125.163 41.1237 125.037 41.1659 124.905 41.1778C124.679 41.2037 124.495 41.1636 124.356 41.0589C124.222 40.9597 124.135 40.8235 124.11 40.6749C124.064 40.3884 124.232 40.0655 124.615 39.7056C125.001 39.342 125.615 39.1115 126.454 39.0166C127.43 38.9063 128.132 39.0893 128.562 39.565C128.793 39.8263 128.951 40.2269 129.039 40.7668L129.432 43.2257C129.471 43.4635 129.517 43.6244 129.572 43.71C129.662 43.8623 129.811 43.9264 130.017 43.9029C130.116 43.8946 130.211 43.869 130.297 43.8278C130.368 43.7908 130.487 43.7063 130.655 43.5751L130.707 43.8937C130.581 44.0621 130.427 44.2142 130.249 44.3454C129.992 44.5328 129.719 44.6425 129.427 44.6757C129.085 44.7146 128.822 44.6523 128.637 44.4902C128.452 44.3175 128.33 44.1035 128.285 43.874C127.946 44.1876 127.651 44.4249 127.401 44.5864C126.979 44.8588 126.562 45.0184 126.149 45.0652C125.733 45.1176 125.309 45.0311 124.967 44.8243C124.61 44.6104 124.402 44.3134 124.34 43.9331Z",
    fill: "#101828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4730_3321",
    x: 80.7305,
    y: 3.61353,
    width: 81.5391,
    height: 76.4939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4730_3321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4730_3321",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionBranding);
export default __webpack_public_path__ + "static/media/institution_branding.05a3e69d3d1c751fa6900a8676dea6dd.svg";
export { ForwardRef as ReactComponent };